<template>
    <li class="case-card">
        <a :href="caseItem.Url" class="case-card__inner">
                <ResponsiveImage v-if="caseItem.HasImage" wrapperClass="case-card__image" :imageModel="caseItem.ImageForVue" />
            <p class="case-card__tag">
                {{caseItem.Solution}}
            </p>
            <p class="case-card__name">
                {{caseItem.Name}}
            </p>
        </a>
    </li>
</template>


<script>
import ResponsiveImage from "./responsiveImage.vue";

    export default {
        name: "caseItem",
        props: ["caseItem"],
        components:{
            ResponsiveImage
        }
    };
</script>